export default {"group":"kL_Mwa_group","scrollable":"kL_Mwa_scrollable",}